import { LlmModel } from '@@types/api.types';
import { z } from 'zod';

export function buildAdminLlmPromptTemplateSchema(params: {
  supportsDefaultModelOverride: boolean;
}) {
  const { supportsDefaultModelOverride } = params;

  return z
    .object({
      defaultModel: z.nativeEnum(LlmModel).optional(),
      template: z.string().trim().min(1, 'Template is required.'),
    })
    .superRefine((value, context) => {
      if (supportsDefaultModelOverride && !value.defaultModel) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Default model is required.',
          path: ['defaultModel'],
        });
      }
    });
}

export type AdminLlmPromptTemplateFormData = z.infer<ReturnType<typeof buildAdminLlmPromptTemplateSchema>>;
